import { format } from 'date-fns';

export function getDateFromLockType(lockType: 0 | 1 | 2): string {
    const date = new Date();
    const multi = lockType === 0 ? 3 : lockType === 1 ? 6 : 12;
    date.setMonth(date.getMonth() + multi);

    return format(date, 'dd.MM.yy');
}
